import React, { FC }     from 'react';
import styled            from 'styled-components';
import {
  ISalesPersonTableRow,
  IReportCU,
}                        from '@typings/accountManagement';
import { CurrencyInput } from '@components/index';
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableRowClassKey,
  TableCellClassKey,
}                        from '@material-ui/core';
import {
  withStyles,
  Styles,
}                        from '@material-ui/styles';

const Header = styled.h2`
  font-size  : 30px;
  margin     : 50px 20px;
  text-align : right;
  width      : 400px;
  color      : ${({ theme: { textColor } }): string => textColor.black};
`;

const FeeField = styled.span`
  font-size   : 14px;
  font-weight : 500;
`;

const Total = styled.span`
  font-size   : 16px;
  font-weight : 600;
`;

const CuName = styled.div`
  text-align    : center;
  font-weight   : 500;
`;

const StyledCurrencyInput = styled(CurrencyInput)`&& {
  margin-right : 15px;
  margin-block : 0;

  .MuiOutlinedInput-root {
    height           : 30px;
    background-color : unset;
  }

  .MuiInputBase-input {
    padding-block: 0;
  }
}`;

const StyledTableRow = withStyles<Styles<{}, {}, TableRowClassKey>>({
  root: {
    display    : 'flex',
    alignItems : 'center',
  },
  footer   : {},
  head     : {},
  hover    : {},
  selected : {},
})(TableRow);

const StyledTableCell = withStyles<Styles<{}, {}, TableCellClassKey>>({
  root: {
    border            : 'none',
    cursor            : 'default',
    width             : 140,
    '&:first-of-type' : {
      width     : 350,
      textAlign : 'right',
    },
  },
  alignCenter     : {},
  alignJustify    : {},
  alignLeft       : {},
  alignRight      : {},
  body            : {},
  footer          : {},
  head            : {},
  paddingCheckbox : {},
  paddingNone     : {},
  sizeSmall       : {},
  stickyHeader    : {},
})(TableCell);

interface IProps {
  salesPersonName : string;
  creditUnions    : IReportCU[];
  reportRows      : ISalesPersonTableRow[];
}

export const ReportDetailsByPerson: FC<IProps> = ({
  salesPersonName,
  creditUnions,
  reportRows,
}) => (
  <>
    <Header>{salesPersonName}</Header>

    <Table>
      <TableHead>
        <StyledTableRow>
          <StyledTableCell />
          {creditUnions.map((CU) => (
            <StyledTableCell key={CU.cuName}>
              <CuName>{CU.cuName}</CuName>
            </StyledTableCell>
          ))}
        </StyledTableRow>
      </TableHead>

      <TableBody>
        {reportRows.map(({ label, values, isTotal }) => (
          <>
            {values.length ? (
              <StyledTableRow key={label}>
                <StyledTableCell>
                  {isTotal
                    ? <Total>{`${label}:`}</Total>
                    : <FeeField>{`${label}:`}</FeeField>}
                </StyledTableCell>

                {values.map((value, index) => (
                  <StyledTableCell key={`${label}_${index}`}>
                    <StyledCurrencyInput
                      value     = {value}
                      textAlign = "left"
                      width     = "125px"
                      disabled
                    />
                  </StyledTableCell>
                ))}
              </StyledTableRow>
            ) : ''}
          </>
        ))}
      </TableBody>
    </Table>
  </>
);
